// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1b0Nl","productName":"Table_productName__3lNCf"};